import { updateUsername } from "actions/updateUserName";
import { updateUserRole } from "actions/updateUserRole";
import { useEffect, useState } from "react";
import { useStateMachine } from "little-state-machine";
import { Auth } from "aws-amplify";
import { useAmplifyREST } from "hooks/useAmplifyREST";
import { stringIsEmpty } from "helpers/stringUtils";
import { resetState } from "actions/resetState";
import { updateSystemSettings } from "actions/updateSystemSettings";
import ISystemSettings from "interfaces/ISystemSettings";
import { IdleTimerProvider } from "react-idle-timer";

const Authenticate = () => {
  const {
    data, sendRequest
  } = useAmplifyREST();

  const {
    data: getSystemSettingsData, sendRequest: getSystemSettingsSendRequest
  } = useAmplifyREST();

  const { state } = useStateMachine();
  const { actions } = useStateMachine(
    {
      updateUsername,
      updateUserRole,
      updateSystemSettings,
      resetState
    }
  );

  const [isLoggingOut, setIsLoggingOut] = useState(false);

  useEffect(() => {
    if (state.loggingOut) {
      setIsLoggingOut(!!state.loggingOut);
    }
  }, [state.loggingOut]);

  useEffect(() => {
    if (isLoggingOut) {
      actions.resetState();
    }
  }, [isLoggingOut]);

  useEffect(() => {
    if (process.env.REACT_APP_AMPLIFY_LIVE_MODE === "true") {
      Auth.currentSession().then(user => {
        // console.log(user);

      });

      Auth.currentAuthenticatedUser()
        .then(user => {
          const getUserName = () => {
            if (user.signInUserSession.idToken.payload.given_name) {
              return `${user.signInUserSession.idToken.payload.given_name} ${user.signInUserSession.idToken.payload.family_name ?? ""}`.trimEnd();
            }

            if (user.signInUserSession.idToken.payload.name) {
              return user.signInUserSession.idToken.payload.name;
            }

            if (user.username) {
              return user.username;
            }

            return undefined;
          };

          const username = getUserName();

          if (!state.username || state.username !== username) {
            actions.updateUsername(username);
          }
        });
    }
  }, [actions, state]);

  useEffect(() => {
    if (stringIsEmpty(state.userRole) && !isLoggingOut) sendRequest("user/role", "GET");
  }, [state.userRole, isLoggingOut, sendRequest]);

  useEffect(() => {
    if (!state.systemSettings && !isLoggingOut) getSystemSettingsSendRequest("settings/system", "GET");
  }, [state.systemSettings, isLoggingOut, getSystemSettingsSendRequest]);

  useEffect(() => {
    if (data && !stringIsEmpty(data.role)) {
      actions.updateUserRole(data.role);
    }
  }, [actions, data]);

  useEffect(() => {
    if (getSystemSettingsData) {
      actions.updateSystemSettings((getSystemSettingsData.systemSettings as ISystemSettings));
    }
  }, [actions, getSystemSettingsData]);

  return (
    <>
      {!state.loggingOut && state.systemSettings && (
        <IdleTimerProvider
          timeout={state.systemSettings.siteTimeout * 60000}
          onPrompt={() => {}}
          onIdle={() => { window.location.href = "/logout"; }}
          onActive={() => {}}
          onAction={() => {}}
        />
      )}
    </>
  );
};

export default Authenticate;
